import { render } from "./AddComplain.vue?vue&type=template&id=4670a579&scoped=true"
import script from "./AddComplain.vue?vue&type=script&lang=js"
export * from "./AddComplain.vue?vue&type=script&lang=js"

import "./AddComplain.vue?vue&type=style&index=0&id=4670a579&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4670a579"]])

export default __exports__